import type { IconData } from '@stacksjs/iconify-core'

export const mediaPause: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M200 48H72a24.03 24.03 0 0 0-24 24v368a24.03 24.03 0 0 0 24 24h128a24.03 24.03 0 0 0 24-24V72a24.03 24.03 0 0 0-24-24m-8 384H80V80h112ZM440 48H312a24.03 24.03 0 0 0-24 24v368a24.03 24.03 0 0 0 24 24h128a24.03 24.03 0 0 0 24-24V72a24.03 24.03 0 0 0-24-24m-8 384H320V80h112Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default mediaPause
